<template>
  <div class="content-container" style="height: auto">
    <div class="content-box">
      <div v-loading="tableLoading" class="section-box outline">
        <search-comp @onSearch="getList" @onReset="onReset">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Hạng phòng</div>
                    <div class="child-w-80">
                      <!-- v-model="searchParams.roomNumber" -->
                      <!-- style="width: 100%" -->
                      <select-with-search-table
                        :rows="roomLevelRows"
                        :columns="roomLevelCols"
                        :dropdown-width="450"
                        index-field="id"
                        :selected-index-field-value="searchParams.roomLevel"
                        :value="searchParams.roomLevel"
                        @selectionChanged="onSelectRowRoomLevel"
                      >
                        <template
                          v-slot:value="{ selectedValue: selectedData }"
                        >
                          {{ selectedData?.name }}
                        </template>
                      </select-with-search-table>
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Khách sạn</div>
                    <div class="child-w-80">
                      <el-select
                        v-model="searchParams.hotelIdList"
                        collapse-tags
                        multiple
                      >
                        <el-option
                          v-for="(hotel, index) in hotelList"
                          :key="index"
                          :value="hotel.id"
                          :label="hotel.name"
                        />
                      </el-select>
                    </div>
                  </div>
                </div>

                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Từ ngày</div>
                    <div class="child-w-80">
                      <!-- :date-data="agentItem.representative_card_date" -->
                      <!-- v-model="agentItem.representative_card_date" -->
                      <!-- @changeCalendar="onChangeDate2" -->
                      <CalendarRange
                        v-model="datetimeRange"
                        style="display: block; width: 500px"
                        mode="date"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </search-comp>
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">{{
                this.$t('route.fillRateReport')
              }}</span>
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div
            ref="agGridWrapper"
            class="grid-scroll mt-10"
            style="height: 400px"
          >
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              dom-layout="scroll"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              :auto-size-cell="true"
            />
          </div>
        </div>
      </div>
      <div v-loading="pieChartLoading" class="section-box outline">
        <search-comp @onSearch="getListPieChart" @onReset="onResetPieChart">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Từ ngày</div>
                    <div class="child-w-80">
                      <!-- :date-data="agentItem.representative_card_date" -->
                      <!-- v-model="agentItem.representative_card_date" -->
                      <!-- @changeCalendar="onChangeDate2" -->
                      <CalendarRange
                        v-model="datetimeRangePieChart"
                        style="display: block; width: 500px"
                        mode="date"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </search-comp>
        <div class="das-form-container mt-10">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="chartwithbutton">
                  <vchart
                    style="height: 400px"
                    class="chart"
                    :option="optionPieChart"
                    autoresize
                    @click="handleClickPieChart"
                  />
                  <div class="button-containers-title">
                    <button class="btn small primary outline download-button">
                      <i class="el-icon-download"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>
      <div v-loading="lineChartLoading" class="section-box outline">
        <search-comp @onSearch="getListLineChart" @onReset="onResetLineChart">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Khách sạn</div>
                    <div class="child-w-80">
                      <el-select
                        v-model="searchParamsLine.hotelIdList"
                        collapse-tags
                        multiple
                      >
                        <el-option
                          v-for="(hotel, index) in hotelList"
                          :key="index"
                          :value="hotel.id"
                          :label="hotel.name"
                        />
                      </el-select>
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Tháng</div>
                    <div class="child-w-80">
                      <el-date-picker
                        v-model="yearMonthLineChart"
                        value-format="yyyy-MM"
                        :disabled="
                          searchParamsLine.dateFrom !== null ||
                          searchParamsLine.dateTo !== null
                        "
                        type="month"
                        placeholder="Vui lòng chọn tháng, năm"
                      >
                      </el-date-picker>
                    </div>
                  </div>
                </div>

                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Từ ngày - Đến ngày</div>
                    <div class="child-w-80">
                      <!-- :date-data="agentItem.representative_card_date" -->
                      <!-- v-model="agentItem.representative_card_date" -->
                      <!-- @changeCalendar="onChangeDate2" -->
                      <CalendarRange
                        v-model="datetimeRangeLineChart"
                        :disabled="
                          searchParamsLine.year !== null ||
                          searchParamsLine.month !== null
                        "
                        style="display: block; width: 500px"
                        mode="date"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </search-comp>
        <div class="das-form-container mt-10">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="chartwithbutton">
                  <vchart
                    style="height: 400px"
                    class="chart"
                    :option="optionLineChart"
                    autoresize
                  />
                  <div class="button-containers-title">
                    <button class="btn small primary outline download-button">
                      <i class="el-icon-download"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>
      <div v-loading="barChartLoading" class="section-box outline">
        <search-comp @onSearch="getListBarChart" @onReset="onResetBarChart">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Từ ngày - Đến ngày</div>
                    <div class="child-w-80">
                      <!-- :date-data="agentItem.representative_card_date" -->
                      <!-- v-model="agentItem.representative_card_date" -->
                      <!-- @changeCalendar="onChangeDate2" -->
                      <CalendarRange
                        v-model="datetimeRangeBarChart"
                        style="display: block; width: 500px"
                        mode="date"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </search-comp>
        <div class="das-form-container mt-10">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="chartwithbutton">
                  <vchart
                    style="height: 400px"
                    class="chart"
                    :option="optionHistogramChart"
                    autoresize
                    @click="handleClickBarChart"
                  />
                  <div class="button-containers-title">
                    <button class="btn small primary outline download-button">
                      <i class="el-icon-download"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>
    </div>

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Hạng phòng: hiển thị hạng phòng (Cấu hình)</li>
            <li>
              Số phòng bị chiếm: Số phòng bị chiếm của hạng phòng trong khoảng
              thời gian tìm kiếm
            </li>
            <li>Tổng số phòng: tổng số phòng vật lý - OOO</li>
            <li>Tỉ lệ: số phòng bị chiếm/tổng số phòng *100. đơn vị %</li>
            <li>Doanh thu: Tổng doanh thu phòng của hạng phòng</li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'

import { getAllHotel } from '@/api/hotel'
import { getListRoomLevelApi } from '@/api/Room/roomLevel'
import {
  getFillRateByDayApi,
  getFillRatePieChartApi,
  getFillRateLineChartApi,
  getFillRateBarChartApi,
  getFillRateByDayApiExcel
} from '@/api/report_service/report_b'
import { PieChart, BarChart, LineChart } from 'echarts/charts'
import { use } from 'echarts/core'
import { color } from '@/utils/color'

use([BarChart, PieChart, LineChart])
import InfoBtn from './components/InfoBtn.vue'
import { downFile } from '@/utils/file-handler'

const getOptionHistogramChartDefault = () => ({
  title: {
    text: 'Doanh thu của các hạng phòng'
    // left: '5%'
  },
  color: color,
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow'
    },
    confine: true,
    extraCssText: 'height: 400px;overflow: scroll;text-wrap: wrap;',
    // valueFormatter: value =>
    //   value !== null && value !== undefined
    //     ? value.toLocaleString('en-US') + ' VND'
    //     : null,
    formatter: params => {
      // return 1
      var tooltipContent = ''
      var axisLabel = params[0].name
      tooltipContent += `<div style="display: flex; flex-direction: row;align-items: center; justify-content: space-between; gap: 8px"><span>${
        params[0].marker
      } ${params[0].seriesName}</span> ${params[0].value.toLocaleString(
        'en-US'
      )} VND</div>`
      tooltipContent += `<div style="display: flex; flex-direction: row;align-items: center; justify-content: space-between; gap: 8px"><span>${
        params[1].marker
      } ${params[1].seriesName}</span> ${params[1].value.toLocaleString(
        'en-US'
      )}%</div>`
      tooltipContent =
        `<span style="font-weight: 600">${axisLabel}</span><br>` +
        tooltipContent
      return tooltipContent
    },
    enterable: true
  },
  // legend: {
  //   orient: 'horizontal',
  //   type: 'scroll',
  //   bottom: 0
  // },
  grid: {
    left: '6%',
    right: '4%',
    top: 70,
    bottom: '0%',
    containLabel: true
  },
  xAxis: [
    {
      type: 'category',
      axisTick: {
        show: true,
        alignWithLabel: true,
        interval: 0
      },
      axisLabel: {
        interval: 0, // Set interval to 0 to display all labels
        rotate: 40 // You can adjust the rotation angle if needed
        // margin: 10 // Set margin to ensure the labels don't get cut off
      },
      data: []
    }
  ],
  yAxis: [
    {
      type: 'value'
    }
  ],
  series: []
})
const getOptionPieChartDefault = () => ({
  title: {
    text: 'Tỉ lệ của từng hạng phòng/ tổng số lấp đầy'
    // left: '5%'
  },
  color: color,
  tooltip: {
    trigger: 'item',
    confine: true,
    extraCssText: 'overflow: scroll;text-wrap: wrap;',
    valueFormatter: value => value + '%'
  },
  legend: {
    orient: 'vertical',
    type: 'scroll',
    textStyle: {
      width: 300,
      overflow: 'break'
    },
    top: 50,
    left: '5%'
    // bottom: 20
  },
  series: [
    {
      name: 'Hạng phòng',
      type: 'pie',
      // right: '10%',
      left: '40%',
      width: '60%',
      avoidLabelOverlap: true,
      radius: '85%',
      data: [],
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      }
    }
  ]
})
const getOptionLineChartDefault = () => ({
  title: {
    text: 'Biểu đồ tăng trưởng của các hạng phòng'
  },
  color: color,
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross'
    },
    confine: true,
    extraCssText: 'height: 300px;overflow: scroll;text-wrap: wrap;',
    valueFormatter: value =>
      value !== null ? value.toLocaleString('en-US') + '%' : null,
    enterable: true
  },
  legend: {
    type: 'scroll',
    bottom: 0
  },
  grid: {
    left: '6%',
    right: '4%',
    top: 70,
    bottom: 60
  },
  xAxis: [
    {
      type: 'category',
      axisTick: {
        alignWithLabel: true
      },
      axisLine: {
        onZero: false
        // lineStyle: {
        //   color: '#5470C6'
        // }
      },
      // axisPointer: {
      //   label: {
      //     formatter: function (params) {
      //       return (
      //         'Precipitation  ' +
      //         params.value +
      //         (params.seriesData.length ? '：' + params.seriesData[0].data : '')
      //       )
      //     }
      //   }
      // },
      // prettier-ignore
      data: []
    }
  ],
  yAxis: [
    {
      type: 'value'
    }
  ],
  series: []
})

export default {
  components: {
    CalendarRange,
    InfoBtn,
    SelectWithSearchTable
  },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        wrapText: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },

      tableLoading: false,
      pieChartLoading: false,
      lineChartLoading: false,
      barChartLoading: false,
      chartKey: 1,
      dialogFormVisible: false,
      hotelList: [],
      roomLevelRows: [],
      roomLevelCols: [
        {
          headerName: 'Mã',
          field: 'code',
          tooltipField: 'code',
          minWidth: 150
        },
        {
          headerName: 'Tên',
          field: 'name',
          tooltipField: 'name',
          minWidth: 200,
          flex: 1
        }
      ],
      searchParams: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        roomLevel: null,
        hotelIdList: []
      },
      searchParamsDefault: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        roomLevel: null,
        hotelIdList: []
      },
      optionPieChart: getOptionPieChartDefault(),
      //   colors: ['#5470C6', '#EE6666', '#ccc'],

      optionLineChart: getOptionLineChartDefault(),
      optionHistogramChart: getOptionHistogramChartDefault(),
      columns: [
        {
          headerName: this.$t('grid.column.roomLevel'),
          field: 'roomLevel',
          tooltipField: 'roomLevel',
          sortable: false
        },
        {
          headerName: this.$t('grid.column.occupiedRoom'),
          field: 'occupiedRoom',
          tooltipField: 'roomLevel',
          // width: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.allRoom'),
          field: 'numOfRoom',
          tooltipField: 'numOfRoom',
          sortable: false
        },
        {
          headerName: this.$t('grid.column.percent'),
          field: 'occupiedRatio',
          cellRenderer: params => params.value + '%',
          // tooltipField: 'occupiedRatio',
          tooltipValueGetter: params => params.value + '%',
          sortable: false
        },
        {
          headerName: this.$t('grid.column.revenue'),
          field: 'revenue',
          valueGetter: params => {
            return this.$displayCurrency(params.data.revenue)
          },
          tooltipValueGetter: params => {
            return this.$displayCurrency(params.data.revenue)
          },
          // tooltipField: 'revenue',
          sortable: false
        }
      ],
      rows: [],

      // filter pie chart
      searchParamsPie: {
        dateTo: this.$moment().format('YYYY-MM-DD'),
        dateFrom: this.$moment().format('YYYY-MM-DD')
      },
      searchParamsPieDefault: {
        dateTo: this.$moment().format('YYYY-MM-DD'),
        dateFrom: this.$moment().format('YYYY-MM-DD')
      },

      // filter line chart
      searchParamsLine: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().add(3, 'day').format('YYYY-MM-DD'),
        month: null,
        year: null,
        hotelIdList: []
      },
      searchParamsLineDefault: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().add(3, 'day').format('YYYY-MM-DD'),
        month: null,
        year: null,
        hotelIdList: []
      },

      // filter bar chart
      searchParamsBar: {
        dateTo: this.$moment().format('YYYY-MM-DD'),
        dateFrom: this.$moment().format('YYYY-MM-DD')
      },
      searchParamsBarDefault: {
        dateTo: this.$moment().format('YYYY-MM-DD'),
        dateFrom: this.$moment().format('YYYY-MM-DD')
      }
    }
  },
  computed: {
    datetimeRange: {
      get() {
        return {
          start: this.searchParams.dateFrom,
          end: this.searchParams.dateTo
        }
      },
      set(val) {
        this.searchParams.dateFrom = val.start
        this.searchParams.dateTo = val.end
      }
    },
    datetimeRangePieChart: {
      get() {
        return {
          start: this.searchParamsPie.dateFrom,
          end: this.searchParamsPie.dateTo
        }
      },
      set(val) {
        this.searchParamsPie.dateFrom = val.start
        this.searchParamsPie.dateTo = val.end
      }
    },
    datetimeRangeLineChart: {
      get() {
        return {
          start: this.searchParamsLine.dateFrom,
          end: this.searchParamsLine.dateTo
        }
      },
      set(val) {
        this.searchParamsLine.dateFrom = val.start
        this.searchParamsLine.dateTo = val.end
      }
    },
    yearMonthLineChart: {
      get() {
        if (
          this.searchParamsLine.year !== null &&
          this.searchParamsLine.month !== null
        ) {
          return this.$moment(
            this.searchParamsLine.year + '-' + this.searchParamsLine.month
          ).format('YYYY-MM')
        }
        return null
      },
      set(val) {
        if (val === null) {
          this.searchParamsLine.year = null
          this.searchParamsLine.month = null
          return
        }
        this.searchParamsLine.year = this.$moment(val, 'YYYY-MM').year()
        this.searchParamsLine.month = this.$moment(val, 'YYYY-MM').month() + 1
      }
    },
    datetimeRangeBarChart: {
      get() {
        return {
          start: this.searchParamsBar.dateFrom,
          end: this.searchParamsBar.dateTo
        }
      },
      set(val) {
        this.searchParamsBar.dateFrom = val.start
        this.searchParamsBar.dateTo = val.end
      }
    }
  },
  async created() {
    await this.getListHotel()

    this.getRoomLevelOptions()
    if (this.$store.state?.app.route?.params?.date_from) {
      this.searchParams.dateFrom = this.$moment(
        this.$store.state?.app.route?.params?.date_from,
        'DD/MM/YYYY'
      ).format('YYYY-MM-DD')
      this.searchParams.dateTo = this.$moment(
        this.$store.state?.app.route?.params?.date_to,
        'DD/MM/YYYY'
      ).format('YYYY-MM-DD')
    }
    await this.getList()
    await this.getListPieChart()
    this.getListLineChart()
    this.getListBarChart()
  },
  methods: {
    handleCommand(cmmd) {
      // this.$message('click on item ' + cmmd)
      switch (cmmd) {
        case 'pdf':
          break
        case 'excel':
          this.downloadExcel()
          break
        default:
          this.$message('click on item ' + cmmd)
          break
      }
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 30

      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    async getRoomLevelOptions() {
      const data = await getListRoomLevelApi()
      this.roomLevelRows = data?.data || []
      // await getRoom()
    },
    onSelectRowRoomLevel(val) {
      this.searchParams.roomLevel = val?.id || null
    },
    async getList() {
      // this.optionHistogramChart = Object.assign(
      //   {},
      //   this.optionHistogramChartDefault
      // )
      if (
        this.searchParams.dateFrom === null ||
        this.searchParams.dateTo === null
      ) {
        this.$message({
          type: 'error',
          message: 'Vui lòng nhập khoảng thời gian.'
        })
        return
      }
      this.tableLoading = true
      this.rows = []
      await getFillRateByDayApi(this.searchParams)
        .then(res => {
          var data = res.data
          for (var i = 0; i < data.length; i++) {
            this.rows.push({ name: data[i].date, isFullWidthRow: true })
            for (var j = 0; j < data[i].infoList.length; j++) {
              this.rows.push(data[i].infoList[j])
            }
          }
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.chartKey = this.chartKey + 1
          this.tableLoading = false
        })
    },
    async downloadExcel() {
      if (
        this.searchParams.dateFrom === null ||
        this.searchParams.dateTo === null
      ) {
        this.$message({
          type: 'error',
          message: 'Vui lòng nhập khoảng thời gian.'
        })
        return
      }
      this.tableLoading = true
      this.rows = []
      await getFillRateByDayApiExcel(this.searchParams)
        .then(res => {
          const date = this.$moment().format('DD-MM-YYYY')
          downFile(res, 'bao_cao_ti_le_lap_day_' + date + '.xlsx')
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.chartKey = this.chartKey + 1
          this.tableLoading = false
        })
    },
    async onReset() {
      this.searchParams = Object.assign({}, this.searchParamsDefault)
      await this.getList()
    },

    async getListPieChart() {
      if (
        this.searchParamsPie.dateFrom === null ||
        this.searchParamsPie.dateTo === null
      ) {
        this.$message({
          type: 'error',
          message: 'Vui lòng nhập khoảng thời gian.'
        })
        return
      }
      this.pieChartLoading = true
      this.optionPieChart = getOptionPieChartDefault()
      // this.rows = []
      await getFillRatePieChartApi(this.searchParamsPie)
        .then(res => {
          var data = res.data
          var total = 0
          data.map(item => {
            total = total + item.occupied_room
          })
          this.optionPieChart.series[0].data = data.map(item => {
            return {
              value: ((item.occupied_room / total) * 100).toFixed(2),
              name: item.room_level
            }
          })
          // for (var i = 0; i < data.length; i++) {
          //   this.rows.push({ name: data[i].date, isFullWidthRow: true })
          //   for (var j = 0; j < data[i].infoList.length; j++) {
          //     this.rows.push(data[i].infoList[j])
          //   }
          // }
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.pieChartLoading = false
        })
    },
    async onResetPieChart() {
      this.searchParamsPie = Object.assign({}, this.searchParamsPieDefault)
      await this.getListPieChart()
    },
    async getListLineChart() {
      if (
        (this.searchParamsLine.dateFrom === null ||
          this.searchParamsLine.dateTo === null) &&
        (this.searchParamsLine.month === null ||
          this.searchParamsLine.year === null)
      ) {
        this.$message({
          type: 'error',
          message: 'Vui lòng nhập khoảng thời gian.'
        })
        return
      }
      this.lineChartLoading = true
      this.optionLineChart = getOptionLineChartDefault()
      // this.rows = []
      var month = null
      if (
        this.searchParamsLine.dateFrom === null &&
        this.searchParamsLine.dateTo === null
      ) {
        month =
          this.$moment({
            year: this.searchParamsLine.year,
            month: this.searchParamsLine.month - 1
          })
            .startOf('month')
            .format('YYYY-MM-DD') || null
      }
      var payload = {
        ...this.searchParamsLine,
        month: month
      }
      await getFillRateLineChartApi(payload)
        .then(res => {
          var data = res.map
          this.optionLineChart.xAxis[0].data = data.date
          for (var i = 0; i < data.occupied_ratio.length; i++) {
            this.optionLineChart.series[i] = {
              name: data.occupied_ratio[i].room_level_name,
              id: data.occupied_ratio[i].room_level_id,
              type: 'line',
              xAxisIndex: 0,
              smooth: true,
              emphasis: {
                focus: 'series'
              },
              data: data.occupied_ratio[i].occupiedRatios
            }
          }
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.lineChartLoading = false
        })
    },
    async onResetLineChart() {
      this.searchParamsLine = Object.assign({}, this.searchParamsLineDefault)
      await this.getListLineChart()
    },
    async getListBarChart() {
      if (
        this.searchParamsBar.dateFrom === null ||
        this.searchParamsBar.dateTo === null
      ) {
        this.$message({
          type: 'error',
          message: 'Vui lòng nhập khoảng thời gian.'
        })
        return
      }
      this.barChartLoading = true
      this.optionHistogramChart = getOptionHistogramChartDefault()
      // this.rows = []
      await getFillRateBarChartApi(this.searchParamsBar)
        .then(res => {
          var data = res.map
          this.optionHistogramChart.xAxis[0].data = data.roomLevels
          this.optionHistogramChart.series[0] = {
            name: 'Doanh thu',
            id: 'Revenue',
            type: 'bar',
            colorBy: 'data',
            label: {
              show: false
              // formatter: params =>
              //   params.value !== 0 ? params.value + '%' : null
            },
            emphasis: {
              focus: 'series'
            },
            barWidth: '70%',
            data: data.revenueRoomLevels.map(item => item.revenue)
          }
          this.optionHistogramChart.series[1] = {
            name: 'Tỉ lệ lấp đầy',
            id: 'FillRate',
            type: 'bar',
            colorBy: 'data',
            label: {
              show: false
              // formatter: params =>
              //   params.value !== 0 ? params.value + '%' : null
            },
            emphasis: {
              focus: 'series'
            },
            barWidth: '0%',
            barGap: '0%',
            data: data.revenueRoomLevels.map(item => item.occupiedRatio)
          }
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.barChartLoading = false
        })
    },
    async onResetBarChart() {
      this.searchParamsBar = Object.assign({}, this.searchParamsBarDefault)
      await this.getListBarChart()
    },
    async handleClickPieChart(e) {
      this.searchParams.dateFrom = this.searchParamsPie.dateFrom
      this.searchParams.dateTo = this.searchParamsPie.dateTo
      this.searchParams.roomLevel = this.roomLevelRows.filter(
        item => item.name === e.name
      )[0].id
      this.searchParams.hotelIdList = []
      await this.getList()
      this.$refs.agGridWrapper.scrollIntoView({ behavior: 'smooth' })
      // change data and time in table filter
    },
    async handleClickBarChart(e) {
      this.searchParams.dateFrom = this.searchParamsBar.dateFrom
      this.searchParams.dateTo = this.searchParamsBar.dateTo
      this.searchParams.roomLevel = this.roomLevelRows.filter(
        item => item.name === e.name
      )[0].id
      this.searchParams.hotelIdList = []
      await this.getList()
      this.$refs.agGridWrapper.scrollIntoView({ behavior: 'smooth' })
      // change data and time in table filter
    }
  }
}
</script>

<style lang="scss" scoped>
.section-box {
  height: auto !important;
}
</style>
